import { Grid, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

interface IFormBlockProps {
  title: string;
  inputField: ReactNode;
}

const FormBlock: React.FC<IFormBlockProps> = (props) => {
  const { title, inputField } = props;

  return (
    <>
      <Grid item xs={12} md={2}>
        <Typography variant="subtitle2" color="text.secondary">
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12} md={10}>
        {inputField}
      </Grid>
    </>
  );
};

export default FormBlock;
